import { Mail, Phone, Globe, User2, File, Tag } from "lucide-react";
import UserInfoItem from "./user-info-item";
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { UserProfile } from "@/pages/users/types/user";

interface UserInfoGridProps {
  user: UserProfile;
}

export function UserInfoGrid({ user }: UserInfoGridProps) {
  const { toast } = useToast();

  return (
    <div
      className="grid gap-4 pt-2.5 sm:grid-cols-1
     xl:grid-cols-2 2xl:grid-cols-3"
    >
      <UserInfoItem
        icon={Phone}
        label="Phone Number"
        value={user.otpless_identifier || "—"}
      />
      {user.emails.length &&
        user.emails.map((email, index) => {
          return <UserInfoItem key={index} icon={Mail} value={email} />;
        })}
      <UserInfoItem
        icon={Globe}
        value={user.country ?? "<country>"}
      />
      <UserInfoItem
        icon={User2}
        label="Age"
        value={user.age ?? "<age>"}
      />
      <UserInfoItem
        icon={User2}
        label="Sex"
        value={user.sex ?? "<sex>"}
      />
      <UserInfoItem
        icon={Globe}
        label="Language"
        value={user.language_preference ?? "<language>"}
      />
      <div className="flex flex-wrap items-center gap-1.5">
        <Tag className="h-4 w-4 shrink-0 text-gray-500" />
        <span className="font-medium">Interested In:</span>
        {user.product_interests?.length ? (
          user.product_interests.map((interest) => (
            <span
              key={interest}
              className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium bg-orange-100 text-orange-800"
            >
              {interest}
            </span>
          ))
        ) : (
          <span>—</span>
        )}
      </div>
      {Object.entries(user.document_ids ?? {}).map(([docType, docId]) => (
        <div key={docType} className="flex items-center gap-2">
          <a
            href={`https://docs.google.com/document/d/${docId}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2"
          >
            <File className="h-4 w-4 shrink-0" />
            <span className="truncate">{docType} document</span>
          </a>
          <Button
            variant="ghost"
            size="sm"
            className="h-8 w-8 p-0 -ml-2"
            onClick={() => {
              const docUrl = `https://docs.google.com/document/d/${docId}`;
              navigator.clipboard.writeText(docUrl);
              toast({
                title: "Copied!",
                description: `${docType} document URL copied to clipboard`,
              });
            }}
          >
            <Copy className="h-4 w-4" />
          </Button>
        </div>
      ))}
    </div>
  );
}

